import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Cross, Warning, Tick, Download } from '../../helpers/icon-dictionary';
import css from './index.scss';
import Button from '../../components/button/index';
import messages from './messages';
import Modal from '../../components/modal/index';
import TeacherUnassign from '../../components/teacher-unassign/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import SignInCardsFormats from '../sign-in-cards-formats';
import ClassCourses from '../class-courses';

class TeacherClassList extends Component {
    constructor(props) {
        super(props);
        this.selectedClassroomId = -1;
    }

    showSignInCardFormat = (classId) => {
        this.selectedClassroomId = classId;
        this.props.handleOnStudentSignInCards();
    }

    renderChildren = () => {
        const {
            unassignTeachersSuccessConfirmation,
            isUnassignedModalOpen,
            handleOnCloseModal,
            handleOnUnassignConfirm,
            isLoading,
            intl,
            showHideSignInCardModal,
            handleOnCancelStudentSignInCards,
            downloadingClassroomIds,
            showUnassignTeacherModal
        } = this.props;
        let children = null;
        if (showUnassignTeacherModal) {
            if (isUnassignedModalOpen) {
                children = (<TeacherUnassign
                    handleOnCancel={handleOnCloseModal}
                    handleOnOk={handleOnUnassignConfirm}
                    icon={Warning}
                    isLoading={isLoading}
                    title={intl.formatMessage(messages.unassignTeacher)}>
                    <div>{intl.formatMessage(messages.selectedTeacherWillBe)} <span className={css.highlight}>{intl.formatMessage(messages.unassigned)}</span> {intl.formatMessage(messages.loseAccessToProducts)}.</div>
                </TeacherUnassign>);
            } else {
                children = (<ConfirmationMessage
                    handleOnCloseModal={unassignTeachersSuccessConfirmation}
                    icon={Tick}
                    title={intl.formatMessage(messages.teachersUnassigned)} />);
            }
        } else if (showHideSignInCardModal) {
            children = (<SignInCardsFormats
                handleOnCancel={handleOnCancelStudentSignInCards}
                handleOnDownloadSignInCards={format => this.props.handleOnPrintClassroomSignInCard(this.selectedClassroomId, format)}
                isSignInCardDownloaded={!downloadingClassroomIds.has(this.selectedClassroomId)} />);
        }
        return children;
    }

    renderCourses = ({ courseName, conquestCourseName, upfCourseName, yearGroup, intl }) => ClassCourses({
        yearGroup,
        courseTitle: courseName,
        conquestCourseTitle: conquestCourseName,
        upfCourseTitle: upfCourseName,
        intl })

    render() {
        const {
            assignedClassrooms,
            handleOnTeacherUnassign,
            showUnassignTeacherModal,
            showHideSignInCardModal,
            intl } = this.props;
        return (<div>
            <div className={css.header}>
                <div className={css.classNameColumn}>{intl.formatMessage(messages.class)}</div>
                <div className={css.courseNameColumn}>{intl.formatMessage(messages.course)}</div>
                <div className={css.yearGroupColumn}>{intl.formatMessage(messages.year)}</div>
                <div className={css.downloadSignInColumn} />
                <div className={css.unassignColumn} />
            </div>
            {
                map(assignedClassrooms, classInfo => (
                    <div className={css.list} key={classInfo.id}>
                        <div className={css.classNameColumn}>{classInfo.name}</div>
                        <div className={css.courseNameColumn}>{this.renderCourses({ ...classInfo, intl })}</div>
                        <div className={css.yearGroupColumn}>{classInfo.yearGroupName}</div>
                        <div className={css.downloadSignInColumn}><Button
                            containerClassName={css.downloadSignInCards}
                            disabled={classInfo.studentsCount < 1}
                            handleOnClick={() => this.showSignInCardFormat(classInfo.id)}
                            icon={Download}
                            iconClassName={css.iconClassName}
                            label={intl.formatMessage(messages.downloadSignInCard)}
                        />
                        </div>
                        <div className={css.unassignColumn}>
                            <Button
                                containerClassName={css.unassignClass}
                                handleOnClick={() => handleOnTeacherUnassign(classInfo.id)}
                                icon={Cross}
                                iconClassName={css.icon} />
                        </div>
                    </div>
                ))
            }
            <Modal show={showUnassignTeacherModal || showHideSignInCardModal}>
                { this.renderChildren() }
            </Modal>
        </div>);
    }
}

TeacherClassList.propTypes = {
    assignedClassrooms: PropTypes.array,
    handleOnTeacherUnassign: PropTypes.func,
    handleOnPrintClassroomSignInCard: PropTypes.func,
    showUnassignTeacherModal: PropTypes.bool,
    unassignTeachersSuccessConfirmation: PropTypes.func,
    isUnassignedModalOpen: PropTypes.bool,
    handleOnUnassignConfirm: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    downloadingClassroomIds: PropTypes.object,
    isLoading: PropTypes.bool,
    intl: intlShape.isRequired,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool
};

export default injectIntl(styleable(css)(TeacherClassList));



// WEBPACK FOOTER //
// ./app/components/teacher-class-list/index.js